module.exports = __webpack_public_path__ + "media/images/logo__admin-08bbddacf9e3cf42a17a0e43b71df187.svg";